import { render, staticRenderFns } from "./WidgetCart.vue?vue&type=template&id=4d4658a6&"
import script from "./WidgetCart.vue?vue&type=script&lang=js&"
export * from "./WidgetCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d4658a6')) {
      api.createRecord('4d4658a6', component.options)
    } else {
      api.reload('4d4658a6', component.options)
    }
    module.hot.accept("./WidgetCart.vue?vue&type=template&id=4d4658a6&", function () {
      api.rerender('4d4658a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/WidgetCart.vue"
export default component.exports